import React, { createContext, useContext, useState, useRef, useCallback } from 'react';
import { IconSpinner, IconPhone, IconSignal, IconBuilding } from './Icons';

// Notifica di progresso per le verifiche SINGOLE (456 / copertura / SSMATE).
// Vive a livello app: resta visibile cambiando pagina e NON si chiude da sola —
// l'utente la chiude con la X dopo aver visto l'esito.
const NOTIF_META = {
  '456': { label: '456', color: '#16a34a', Icon: IconPhone },
  copertura: { label: 'Copertura', color: '#3b82f6', Icon: IconSignal },
  ssmate: { label: 'SSMATE', color: '#eab308', Icon: IconBuilding },
  gea: { label: 'Vodafone', color: '#e60000', Icon: IconSignal },
};

const Ctx = createContext(null);
export const useSingleNotif = () => useContext(Ctx) || { start: () => 0, done: () => {}, close: () => {} };

export function SingleNotifProvider({ children }) {
  const [notifs, setNotifs] = useState([]);
  const idRef = useRef(0);

  const start = useCallback((agent, label) => {
    const id = ++idRef.current;
    setNotifs(prev => [...prev, { id, agent, label, status: 'running', text: 'in corso…', color: '#64748b' }]);
    return id;
  }, []);
  const done = useCallback((id, text, color) => {
    setNotifs(prev => prev.map(n => (n.id === id ? { ...n, status: 'done', text, color } : n)));
  }, []);
  const close = useCallback((id) => setNotifs(prev => prev.filter(n => n.id !== id)), []);

  return (
    <Ctx.Provider value={{ start, done, close }}>
      {children}
      {notifs.length > 0 && (
        <div className="single-notif">
          {notifs.map((n) => {
            const meta = NOTIF_META[n.agent] || NOTIF_META['456'];
            const Icon = meta.Icon;
            return (
              <div key={n.id} style={{ background: 'var(--surface)', border: '1px solid #e2e8f0', borderLeft: `4px solid ${meta.color}`,
                borderRadius: 10, boxShadow: '0 8px 26px rgba(0,0,0,.16)', padding: '10px 12px', display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ color: meta.color, display: 'inline-flex', flex: '0 0 auto' }}>
                  {n.status === 'running' ? <IconSpinner size={16} /> : <Icon size={16} />}
                </span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: '#0f172a', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {meta.label} · {n.label}
                  </div>
                  <div style={{ fontSize: 12, color: n.status === 'done' ? n.color : '#64748b' }}>{n.text}</div>
                </div>
                <button onClick={() => close(n.id)} title="Chiudi"
                  style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', fontSize: 13, padding: 2, flex: '0 0 auto' }}>✕</button>
              </div>
            );
          })}
        </div>
      )}
    </Ctx.Provider>
  );
}
